import { useContext } from 'react';

import { Card, Typography } from '@occc-app/design-system';

import LocationTestingDashboard from './location-testing-dashboard.component';

import { LocationContext } from '../LocationProvider';

export const LocationTestingDashboardContainer = () => {
  const { location } = useContext(LocationContext);

  if (!location) {
    return (
      <Card sx={{ py: 10, px: 2 }}>
        <Typography color='error' textAlign='center'>
          No data. Something went wrong. Please try again.
        </Typography>
      </Card>
    );
  }

  return <LocationTestingDashboard location={location} />;
};
